import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import Inward_logo from "../../../assets/assets/inward_logo.svg";
import {
  clearNipTestState,
  initiateTest,
  submitOutwardTest,
} from "../../../redux/Actions/OutwardTestActions";
import Spinner from "react-spinner-material";
import Button from "../../Button/Button";
import SuccessModal from "./SuccessModal";
import TestWrapper from "./TestWrapper";

const InwardIntegration = (props) => {
  const {
    initiateTest,
    isInitiatingTest,
    initiateSuccess,
    submitInwardTest,
    submitTestSuccess,
    testItems,
    testMessage,
    isSubmitting,
    clearNipTestState,
  } = props;

  const appId = props.location.state && props.location.state.appId;
  const history = useHistory();

  const [state, setState] = useState({
    index: 0,
    showMore: false,
    show: true,
  });

  const [modal, setModal] = useState({
    visible: false,
  });

  useEffect(() => {
    clearNipTestState();
    // eslint-disable-next-line
  }, [clearNipTestState]);

  const testId = testItems && testItems.nipTestId;
  const payload = { nipTestId: testId };
  const testResults = testItems && testItems.processesCompleted;
  const testErrors = testItems && testItems.error;

  const startInwardTest = () => {
    setState({
      ...state,
      show: false,
    });
    const payload = {
      applicationId: appId,
    };
    const type = "inward";
    initiateTest(type, payload);
  };

  const submitTest = () => {
    setState({
      ...state,
      show: false,
    });
    submitInwardTest(payload);
  };

  const hide = () => {
    setModal({ ...modal, visible: false });
    history.push({
      pathname: `/nip/integration/${appId}`,
      state: {
        id: appId,
      },
    });
  };

  useEffect(() => {
    if (submitTestSuccess) {
      setModal({ ...modal, visible: true });
    }
    // eslint-disable-next-line
  }, [submitTestSuccess, setModal]);

  return (
    <TestWrapper logo={Inward_logo} name={"Inward"}>
      {state.show ? (
        <div className="before-initiate">
          <div className="before-initiate-header">Run Inward Test</div>
          <div className="before-initiate-box">
            <div className="before-initiate-box-circle">i</div>
            <span className="before-initiate-box-text">
              Ensure your application is running before initiating the test
            </span>
          </div>

          <div className="before-initiate-btn">
            <Button
              testId="initiateTest"
              onClick={() => startInwardTest()}
              width="180px"
              height="50px"
              text={"INITIATE TEST"}
              type="submit"
            />
          </div>
        </div>
      ) : (
        <div className="inward-integration-table">
          <p className="inward-integration-table-title">Run Inward Test</p>
          <p className="inward-integration-table-title2">
            All tests must be completed before you can proceed
          </p>
          {isInitiatingTest ? (
            <div className="center-spinner">
              <Spinner
                size={120}
                color={"#047558"}
                spinnerwidth={5}
                visible={true}
              />
            </div>
          ) : initiateSuccess ? (
            <div>
              {testResults &&
                testResults.map((result, index) => (
                  <div className="inward-integration-table-wrap" key={index}>
                    <div className="inward-integration-table-data">
                      <div className="inward-integration-table-data-left2">
                        {result}
                      </div>
                      <div className="inward-integration-table-data-right">
                        Passed
                      </div>
                    </div>
                  </div>
                ))}

              {testErrors && Object.keys(testErrors).length !== 0 ? (
                <div className="inward-integration-table-wrap">
                  <div className="inward-integration-table-data3">
                    <div className="inward-integration-table-data3-top">
                      <div className="inward-integration-table-data3-left">
                        {(testErrors && testErrors.process) || "Nil"}
                      </div>
                      <div className="inward-integration-table-data3-right">
                        Failed
                      </div>
                    </div>

                    <div className="inward-integration-table-data3-bottom">
                      <div className="inward-integration-table-data3-left3">
                        Response:
                      </div>
                      <div className="inward-integration-table-data3-left2">
                        {(testErrors && testErrors.response) || "Not available"}
                      </div>
                    </div>

                    <div className="inward-integration-table-data3-bottom">
                      <div className="inward-integration-table-data3-left3">
                        Message:
                      </div>
                      <div className="inward-integration-table-data3-left2">
                        {(testErrors && testErrors.message) || "Not available"}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div></div>
              )}
            </div>
          ) : (
            <div className="nip-error">Error Initiating Inward Test</div>
          )}

          <br />
          {!isInitiatingTest && (
            <div className="flex-button">
              {testMessage === "Inward integration test failed" && (
                <Button
                  testId="submitTest"
                  onClick={() => startInwardTest()}
                  disabled={isInitiatingTest}
                  width="151px"
                  height="50px"
                  text={"RERUN"}
                  type="submit"
                />
              )}

              {testMessage === "Inward integration test is successful" && (
                <Button
                  testId="submitTest"
                  onClick={() => submitTest()}
                  disabled={isSubmitting}
                  width="151px"
                  height="50px"
                  text={isSubmitting ? "SUBMITTING.." : "SUBMIT"}
                  type="submit"
                />
              )}
            </div>
          )}
        </div>
      )}

      {submitTestSuccess && (
        <SuccessModal hide={hide} visible={modal.visible} />
      )}
    </TestWrapper>
  );
};

InwardIntegration.propTypes = {
  clearNipTestState: PropTypes.func,
  initiateSuccess: PropTypes.any,
  initiateTest: PropTypes.func,
  isInitiatingTest: PropTypes.any,
  isSubmitting: PropTypes.any,
  location: PropTypes.shape({
    state: PropTypes.number,
  }),
  submitInwardTest: PropTypes.any,
  submitTestSuccess: PropTypes.any,
  testItems: PropTypes.shape({
    error: PropTypes.any,
    nipTestId: PropTypes.any,
    processesCompleted: PropTypes.any,
  }),
  testMessage: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    isInitiatingTest: state.outwardTest.isInitiatingTest,
    isSubmitting: state.outwardTest.isSubmitting,
    initiateSuccess: state.outwardTest.initiateSuccess,
    submitTestSuccess: state.outwardTest.submitTestSuccess,
    testItems: state.outwardTest.testItems && state.outwardTest.testItems.data,
    testMessage:
      state.outwardTest.testItems && state.outwardTest.testItems.message,
  };
};

const mapDispatchToProps = (dispatch) => ({
  clearNipTestState: () => dispatch(clearNipTestState()),
  initiateTest: (type, payload) => dispatch(initiateTest(type, payload)),
  submitInwardTest: (payload) => dispatch(submitOutwardTest(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InwardIntegration);
